import React from "react";
import { BuyingGuideSection } from "../Types/BuyingGuideSection";

export default function BuyingGuideImageFull({
  section,
}: {
  section: BuyingGuideSection;
}) {
  const content = section?.contents[0] ?? undefined;

  return (
    <div className="guide-section full-image-template">
      {content !== undefined && content.imageLink.length > 0 ? (
        <a href="#guide-header" target="_blank">
          <img
            style={{ margin: "0, auto", display: "block" }}
            src={content.imageUrl}
            alt={content.imageAlternateText}
          />
        </a>
      ) : (
        <img
          style={{ margin: "0, auto", display: "block" }}
          src={content?.imageUrl}
          alt={content?.imageAlternateText}
        />
      )}
    </div>
  );
}
